<template>
  <div class="charts-bar" :style="height ? 'height:' + height : ''">
    <div class="charts-bar-chart__canvas" :id="id"></div>
  </div>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "chartsBar",
  mixins: [global],
  props: {
    id: String,
    data: Object,
    title: String,
    height: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      myChart: null,
      mydata: {
        title: this.$l("数据分布图"),
        category: [],
        legendShow: true,
        labelShow: true,
        value: [],
      },
    };
  },
  watch: {
    data(val) {
      if (val) {
        this.mydata = val;
        if (this.id.slice(0, this.id.length - 1) == "device_chartsCategory") {
          this.SetEchart2();
        } else {
          this.SetEchart();
        }
      }
    },
  },
  mounted() {
    if (this.data) {
      this.mydata = this.data;
    }
    if (
      this.id.slice(0, this.id.length - 1) == "device_chartsCategory" ||
      this.id.slice(0, this.id.length - 2) == "device_chartsCategory"
    ) {
      this.SetEchart2();
    } else {
      this.SetEchart();
    }
  },
  methods: {
    setId() {
      return "charts-bar-chart__" + this.index;
    },
    SetEchart() {
      var id = this.id;
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(id));
      // 绘制图表
      var category = this.mydata.category;
      var option = {
        title: {
          text: this.mydata.title,
          top: 7,
          left: 10,
          textStyle: {
            // color: this.colorPrimary,
            fontSize: 15,
          },
        },
        legend: {
          show:
            this.mydata.legendShow !== ("" || undefined)
              ? this.mydata.legendShow
              : true,
          top: 10,
          // left: "center"
          right: 20,
          icon: "circle",
          itemGap: 10, // 间隔
          itemWidth: 10, // 图形宽度。
          itemHeight: 10,
          // data: legend,
          textStyle: {
            color: this.chartConfig.legendFontColor,
          },
        },
        color: [this.colorPrimary, this.colorInfo],
        // color: this.chartConfig.colorList,
        grid: {
          top: 30,
          left: 30,
          right: 30,
          bottom: 20,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: this.chartConfig.shadowColor,
            },
          },
        },
        yAxis: {
          type: "value",
          // name: '万元',
          axisLine: {
            show: false,
            lineStyle: {
              color: this.chartConfig.lineColor,
            },
          },
          axisTick: { show: false },
          axisLabel: {
            show: false,
            color: this.chartConfig.labelColor,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: this.chartConfig.splitLineColor,
            },
          },

          // max(value) {
          //   return value.max * 1.2;
          // }
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: this.chartConfig.lineColor,
            },
          },
          axisLabel: {
            show: true,
            color: this.chartConfig.labelColor,
            fontSize: 12,
          },
          splitLine: {
            show: false,
          },
          axisTick: { show: false },
          data: category,
        },
        series: [],
      };

      let arr = [];

      var color1 = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "rgba(223,69,69,1)" },
        { offset: 1, color: "rgba(223,69,69,0.3)" },
      ]);
      var color2 = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: "rgba(149,156,166,1)" },
        { offset: 1, color: "rgba(149,156,166,0.3)" },
      ]);

      var colorList = ["#df4545", "blue"];
      this.mydata.value.map((item) => {
        let seriesItem = {
          name: item.name,
          type: "bar",
          barWidth: "25%",
          barMaxWidth: "24",
          label: {
            normal: {
              show: this.mydata.labelShow ? this.mydata.labelShow : false,
              position: "top",
              // color: "#df4545",
              // color: "#545E6D",
              color: "#666",
              fontSize: 15,
              // formatter: '{c}'
            },
          },
          itemStyle: {
            // barBorderRadius: 20,
            normal: {
              barBorderRadius: [6, 6, 0, 0],
              // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //   { offset: 0, color: "rgba(223,69,69,1)" },
              //   { offset: 1, color: "rgba(223,69,69,0.3)" },
              // ]),
              // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //   { offset: 0, color: "rgba(84,94,109,0.6)" },
              //   { offset: 1, color: "rgba(84,94,109,0.18)" },
              // ]),
              color: function (params) {
                // var color1 = "red";
                // var color2 = "blue";
                if (params.dataIndex % 2 == 0) {
                  return color1;
                } else {
                  return color2;
                }
                // return colorList[params.dataIndex];
              },
            },
          },
          data: item.data,
        };
        arr.push(seriesItem);
      });

      option.series = arr;

      this.myChart.setOption(option);

      this.myChart.on("click", (params) => {
        this.onClick(params);
      });
    },
    SetEchart2() {
      var data = [];
      data.push({
        value: this.mydata.totalCount,
        itemStyle: { color: "#ECEDF7" },
      });
      data.push({ value: this.mydata.count1, itemStyle: { color: "#5FFCFA" } });
      data.push({ value: this.mydata.count2, itemStyle: { color: "#3EE548" } });
      data.push({ value: this.mydata.count3, itemStyle: { color: "#FFDD17" } });
      data.push({ value: this.mydata.count4, itemStyle: { color: "#FF4D39" } });
      data.push({ value: this.mydata.count5, itemStyle: { color: "#ECEDF7" } });
      data.push({ value: this.mydata.count6, itemStyle: { color: "#FF9833" } });
      this.myChart = this.$echarts.init(document.getElementById(this.id));
      var option = {
        grid: {
          bottom: "15%",
          right: "5%",
          top: "15%",
          left: "5%",
        },
        xAxis: {
          type: "category",
          data: [
            this.$l("总量"),
            this.$l("正常"),
            this.$l("遥监"),
            this.$l("检修"),
            this.$l("故障"),
            this.$l("困人"),
            this.$l("保养"),
          ],
          axisLabel: {
            color: "#A6B3CC",
            fontWeight: "400",
            fontFamily: "Alibaba PuHuiTi",
            fontSize: "14",
          },
          axisLine: {
            lineStyle: {
              color: "#27948E",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#27948E",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#27948E",
              type: "dashed",
            },
          },
        },
        aria: {
          enabled: true,
          decal: {
            show: true,
          },
        },
        series: [
          {
            data: data,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "#1E5D92",
            },
            label: {
              show: true,
              position: "top",
            },
            barWidth: "20%",
          },
        ],
      };

      this.myChart.setOption(option);
    },
    onClick(params) {
      this.$emit("on-click", params);
    },
    initChart() {
      if (this.id.slice(0, this.id.length - 1) == "device_chartsCategory") {
        this.SetEchart2();
      } else {
        this.SetEchart();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.charts-bar {
  width: 100%;
  height: 100%;
  &-chart {
    &__canvas {
      width: 100%;
      height: 100%;
      // background: transparent;
    }
  }
}
</style>
